module.exports = __webpack_public_path__ + "img/back-primary.349db462.svg";